export default function BookingIcon(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 6.66732H2M14 7.66732V5.86732C14 4.74721 14 4.18716 13.782 3.75934C13.5903 3.38301 13.2843 3.07705 12.908 2.8853C12.4802 2.66732 11.9201 2.66732 10.8 2.66732H5.2C4.0799 2.66732 3.51984 2.66732 3.09202 2.8853C2.71569 3.07705 2.40973 3.38301 2.21799 3.75934C2 4.18716 2 4.74721 2 5.86732V11.4673C2 12.5874 2 13.1475 2.21799 13.5753C2.40973 13.9516 2.71569 14.2576 3.09202 14.4493C3.51984 14.6673 4.0799 14.6673 5.2 14.6673H7M10.6667 1.33398V4.00065M5.33333 1.33398V4.00065M9.33333 14.6673L10.6833 14.3973C10.801 14.3738 10.8599 14.362 10.9148 14.3405C10.9635 14.3214 11.0098 14.2966 11.0527 14.2667C11.101 14.233 11.1435 14.1905 11.2284 14.1056L14 11.334C14.3682 10.9658 14.3682 10.3689 14 10.0007C13.6318 9.63248 13.0349 9.63248 12.6667 10.0007L9.89503 12.7723C9.81015 12.8572 9.76771 12.8996 9.73399 12.948C9.70405 12.9909 9.67928 13.0372 9.66017 13.0859C9.63864 13.1408 9.62687 13.1996 9.60333 13.3174L9.33333 14.6673Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
